<template>
  <header class="bg-body shadow-md py-3 px-6 flex items-center justify-between">
    <div v-if="true" class="flex justify-center">
      <img
        :src="require('@/assets/IMF.svg')"
        alt="IMF header"
        class="w-20 h-16"
      />
    </div>

    <div class="relative hidden lg:block">
      <button
        @click="toggleDropdown"
        class="text-gray-700 font-medium flex items-center space-x-2 hover:text-blue-600 transition"
      >
        <span>{{ $store.state.userLogged }}</span>
        <ChevronDown />
      </button>

      <div
        v-if="isDropdownOpen"
        class="fixed inset-0 z-40"
        @click.self="isDropdownOpen = false"
      >
        <div
          class="absolute right-4 top-16 w-48 bg-white border border-gray-200 rounded-xl shadow-xl z-50 max-h-64 overflow-auto"
        >
          <ul class="text-sm text-gray-700 divide-y divide-gray-100">
            <li v-for="(item, index) in itemList" :key="index">
              <router-link
                @click.self="isDropdownOpen = false"
                :to="item.route"
                class="flex justify-between items-center px-4 py-3 hover:bg-gray-50"
              >
                <span>{{ item.name }}</span>
                <span
                  v-if="item.name === 'Electronic Files'"
                  class="text-[10px] font-semibold uppercase bg-gradient-to-r from-blue-100 to-blue-200 text-blue-800 px-2 py-1 rounded-full shadow-sm tracking-wide"
                >
                  Soon
                </span>
              </router-link>
            </li>

            <li>
              <button
                class="w-full text-left px-4 py-3 hover:bg-red-50 text-red-600 font-medium"
                @click="handleLogout"
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { ref, inject } from "vue";
import { useRouter } from "vue-router";
import ChevronDown from "@/components/svgs/chevronDown.vue";

export default {
  components: { ChevronDown },
  setup() {
    const isDropdownOpen = ref(false);
    const router = useRouter();
    const axios = inject("$axios");
    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value;
    };
    const itemList = ref([
      {
        id: 1,
        name: "My Profile",
        route: "/portal/account/profile",
      },
      {
        id: 2,
        name: "Transaction History",
        route: "/portal/transaction",
      },
      {
        id: 3,
        name: "Electronic Files",
        route: "/portal/transaction",
      },

      {
        id: 4,
        name: "Account Setting",
        route: "/portal/transaction",
      },
    ]);
    const handleLogout = async () => {
      try {
        await axios.post(`/api/patient/signout`);
        router.push("/");
      } catch (error) {
        console.error("Sign-out error:", error);
      }
    };

    return {
      isDropdownOpen,
      toggleDropdown,
      handleLogout,
      itemList,
    };
  },
};
</script>
